import React, { useLayoutEffect, useRef, useState } from "react";
import { W, H } from "./ccUtils";

// Renders a fixed 1920x1080 canvas scaled to fit (and centred in) its parent, so nothing ever scrolls.
export function ScaleCanvas({ children, testid = "cc-scale-canvas" }) {
  const ref = useRef(null);
  const [box, setBox] = useState(null);
  useLayoutEffect(() => {
    const el = ref.current;
    let raf = 0;
    const fit = () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => setBox({ w: el.clientWidth, h: el.clientHeight }));
    };
    setBox({ w: el.clientWidth, h: el.clientHeight });
    const ro = new ResizeObserver(fit);
    ro.observe(el);
    return () => { ro.disconnect(); cancelAnimationFrame(raf); };
  }, []);
  const s = box ? Math.min(box.w / W, box.h / H) : 0;
  return (
    <div ref={ref} className="relative w-full h-full overflow-hidden" data-testid={testid}>
      {s > 0 && (
        <div className="absolute origin-top-left" data-scale={s.toFixed(3)}
          style={{ width: W, height: H, transform: `scale(${s})`, left: (box.w - W * s) / 2, top: (box.h - H * s) / 2 }}>
          {children}
        </div>
      )}
    </div>
  );
}
